const Vue = window.Vue;
const VueRouter = require('vue-router').default;

const creditBureauRouter = new VueRouter({
  routes: [
    {
      name: 'credit-bureau',
      path: '/',
      component: require('./components/pages/credit-bureau/List.vue').default
    },
    {
      name: 'credit-bureau-view-as-contract',
      path: '/view-contract/:id',
      component: require('./components/pages/transaction-contract/View.vue').default,
      props: {
        isShowCredit: true,
      },
    }
  ],
})

Vue.component('credit-bureau-app', require('./components/pages/credit-bureau/Index.vue').default)

if ($('#credit-bureau-app').length) { // for transaction-contract-app
  const app = new Vue({
    router: creditBureauRouter
  }).$mount('#credit-bureau-app');
}